import './BenefitsBox.scss';

import React from 'react';
import { ReactComponent as ExternalArrow } from 'assets/icons/link-external.svg';
import { Link } from 'react-router-dom';

function BenefitsBox({ link, newTab, children }) {
  const benefitsBox = [
    <div key="child" className="fill-space">
      {children}
    </div>,
    <div key="arrow" className="box-arrow">
      <div className="fill-space" />
      <ExternalArrow />
    </div>
  ];

  return link.indexOf('/') === 0 ? (
    <Link className="box" to={link}>
      {' '}
      {benefitsBox}{' '}
    </Link>
  ) : (
    <a
      href={link}
      target={newTab ? '_blank' : '_self'}
      rel="noreferrer"
      className="box">
      {' '}
      {benefitsBox}{' '}
    </a>
  );
}

export default BenefitsBox;
